import React, { useEffect } from "react"
import { Box, Paper, Stack, Typography } from "@mui/material"
import { useTheme } from '@mui/material/styles'

const lightyellow = '#fff9c4'
const lightblue = '#e3f2fd'
const lightgreen = '#e8f5e9'
const lightpink = '#ffebee'

const darkyellow = '#5f4b00'
const darkblue = '#0d47a1'
const darkgreen = '#1b5e20'
const darkpink = '#880e4f'


export default function About(props) {
    const theme = useTheme()

  return (
    <Paper>
      <Stack spacing={3} sx={{ px: {xs: '1rem', sm: '4rem'}, py: '2rem' }}>
        <Typography variant='h4'>About</Typography>
        <Typography variant='body1'>
          Hi, I'm Marina. I love cycling and all things bicycles.
        </Typography>

        <Box
            component="img"
            sx={{
              height: {xs: 250, md: 350},
              // width: '60%',
              objectFit: 'cover',
              padding: 0,
            }}
            alt="event picture"
            src='/about.jpg'
            borderRadius={2}
          />

        <Typography variant='body1'>
          I believe that one of the best ways to learn is from others, and am grateful for having a great cycling community around me.
          These wonderful people are a great source of inspiration and knowledge.
        </Typography>

        <Typography variant='body1'>
          I built this website because I would like every one to have an easy way to connect with their local bicycling communities.
          Many people (myself included) might be nervous about whether they can keep up on a group ride, or even have imposter syndrome.
          I am hoping that by making all of the details of a group ride available, folks will have less barriers to connecting with their local bike community through rides.
        </Typography>

        <Typography variant='body1'>
          Additionally, I hope to solve the problem of finding and keeping track of group rides to begin with.
          I've found that many bike organizations use multiple channels to announce and update their rides (social media, Signal groups, emails, Google docs, Google groups, etc.), making it very difficult to keep track of the official what/when/where without having to sign up and actively watch multiple places.
          I believe that having an easily-accessible "single source of truth" will help alleviate some of the stress that prevents locals from connecting with their bike community.
        </Typography>

        <Typography variant='body1'>
          I hope to see you on a ride soon!
        </Typography>
      </Stack>
    </Paper>
  )
}
